import React, { useEffect, useState } from "react";
import { apiClient } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Boxes, Cog, Loader2 } from "lucide-react";
import CartalVerifiedPartnersStrip from "../components/CartalVerifiedPartnersStrip";

export function PartsPage() {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  useEffect(() => { apiClient.get("/parts").then(({ data }) => setItems(data.items || [])); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-12" data-testid="parts-page">
      <div className="overline mb-2">SPARE PARTS MARKETPLACE</div>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight font-medium">{lang === "ar" ? "قطع غيار أصلية وبديلة" : "OEM & Aftermarket Parts"}</h1>
      <p className="text-[#6b6b6b] mt-2 max-w-2xl">{lang === "ar" ? "من متاجر ومصنّعين ووكلاء موثوقين في كارتال." : "From verified stores, dealers and manufacturers across CARTAL."}</p>
      <CartalVerifiedPartnersStrip categories={["parts_store", "tire_battery_shop", "salvage"]} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {items.map((p) => (
          <div key={p.id} className="surface rounded-2xl p-6 " data-testid={`part-${p.id}`}>
            <div className="w-10 h-10 rounded-xl bg-[#c9a55c]/15 border border-[#c9a55c]/40 flex items-center justify-center mb-3"><Boxes className="w-5 h-5 text-[#8a6f2e]" /></div>
            <div className="font-display text-lg leading-tight">{p.name_en}</div>
            <div className="text-xs text-[#6b6b6b] mt-1">{p.fits}</div>
            <div className="mt-3 flex items-end justify-between">
              <div><span className="pill text-[10px]">{p.category}</span></div>
              <div className="font-display text-2xl text-[#8a6f2e]">{p.price_sar.toLocaleString()} <span className="text-xs text-[#6b6b6b]">SAR</span></div>
            </div>
            <div className="text-xs text-[#6b6b6b] mt-2">Stock: {p.stock} · ⭐ {p.rating}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ServicesPage() {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  useEffect(() => { apiClient.get("/services").then(({ data }) => setItems(data.items || [])); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-12" data-testid="services-page">
      <div className="overline mb-2">SERVICE & MAINTENANCE</div>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight font-medium">{lang === "ar" ? "احجز خدمة" : "Book a service"}</h1>
      <p className="text-[#6b6b6b] mt-2 max-w-2xl">{lang === "ar" ? "من زيت إلى صيانة دورية كاملة — ورش وفنيون متنقلون." : "From oil changes to full periodic maintenance — workshops & mobile mechanics."}</p>
      <CartalVerifiedPartnersStrip categories={["workshop", "car_wash", "recovery_towing", "tire_battery_shop"]} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {items.map((s) => (
          <div key={s.id} className="surface rounded-2xl p-6  flex flex-col" data-testid={`service-${s.id}`}>
            <div className="w-10 h-10 rounded-xl bg-[#c9a55c]/15 border border-[#c9a55c]/40 flex items-center justify-center mb-3"><Cog className="w-5 h-5 text-[#8a6f2e]" /></div>
            <div className="font-display text-lg">{s.name}</div>
            <div className="text-xs text-[#6b6b6b] mt-1">{s.provider} · {s.type}</div>
            <div className="mt-auto flex items-end justify-between pt-4">
              <div className="text-xs text-[#6b6b6b]">{s.duration_minutes}m</div>
              <div className="font-display text-2xl text-[#8a6f2e]">{s.price_sar.toLocaleString()} <span className="text-xs text-[#6b6b6b]">SAR</span></div>
            </div>
            <button className="btn-primary w-full justify-center text-sm mt-4">{lang === "ar" ? "احجز" : "Book"}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
